import { NgModule } from '@angular/core';
import { FormatHoursPipe } from './format-hours.pipe';

@NgModule({
  declarations: [FormatHoursPipe],
  exports: [FormatHoursPipe]
})
export class DateFormatModule {}
